export default {
  request: {
    baseURL: process.env.NODE_ENV === 'production' ? '/api' : '/dev',
    timeout: 10000,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      version: '10001',
    },
  },
};
